import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const usePageUrl = () => {
  const { asPath } = useRouter();

  const url = useMemo(() => {
    let pathname = asPath.split('?')[0];

    if (pathname === '/index') {
      pathname = '/';
    }

    pathname = pathname.toLowerCase();

    return new URL(pathname, process.env.NEXT_PUBLIC_FE_BASE_URL ?? null).href;
  }, [asPath]);

  return url;
};
